/*
 * Recommended VS Code Extension – "Comment Anchors" exodiusstudios.comment-anchors */
import GlobalFallbackSkeleton from 'packages/lib/common-ui/app-shell/app-layout';
import AnnotationToolSkeleton from 'packages/at-shell/components/app-shell/app-layout';
import { Suspense, lazy } from 'react';
import { Switch, useRouteMatch, Redirect } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { customDefaultTheme } from 'packages/lib/common-ui/theme';
import { AnnotationToolRoute } from 'packages/main/routes/components/annotation-tool-route';
import AppPageSkeleton from 'packages/lib/common-ui/app-shell/app-layout';

/**
 * ANCHOR - Tools & Views
 */
const PolarisPortal = lazy(() => import('packages/main/pages/polaris/portal'));
const PolarisTool = lazy(() => import('packages/main/pages/polaris/tool'));

/**
 * ANCHOR - Error Pages
 */
const ErrorPage404 = lazy(
  () => import('packages/lib/common-ui/error-pages/error-page-404')
);

const ErrorPage403 = lazy(
  () => import('packages/lib/common-ui/error-pages/error-page-403')
);

export function Contractor(): JSX.Element {
  const match = useRouteMatch();
  return (
    <ConfigProvider
      theme={{
        ...customDefaultTheme,
        token: {
          borderRadius: 6,
        },
      }}
    >
      <Suspense fallback={<GlobalFallbackSkeleton />}>
        <Switch>
          {/**
           * ANCHOR - Contractor Task Portal Routes
           */}
          <AnnotationToolRoute path={`${match.url}/tools`} exact>
            <Suspense fallback={<AppPageSkeleton />}>
              <PolarisPortal />
            </Suspense>
          </AnnotationToolRoute>
          <AnnotationToolRoute exact path={`${match.url}`}>
            <Redirect to="/mobis/tools" />
          </AnnotationToolRoute>

          <AnnotationToolRoute path={`${match.url}/data-requests`} exact>
            <Suspense fallback={<AppPageSkeleton />}>
              <PolarisPortal />
            </Suspense>
          </AnnotationToolRoute>

          <AnnotationToolRoute path={`${match.url}/polaris/:query?`} exact>
            <Suspense
              fallback={<AnnotationToolSkeleton skeletonMode theme="dark" />}
            >
              <PolarisTool />
            </Suspense>
          </AnnotationToolRoute>

          {/**
           * ANCHOR - Handle awkwardly non-existent paths
           */}
          <AnnotationToolRoute path={`${match.url}/tasks`} exact>
            <Redirect to={`${match.url}/tools`} />
          </AnnotationToolRoute>
          <AnnotationToolRoute path={`${match.url}/403`} exact>
            <ErrorPage403 />
          </AnnotationToolRoute>
          <AnnotationToolRoute path={`${match.url}/:no_path`} exact>
            <ErrorPage404 />
          </AnnotationToolRoute>
          <AnnotationToolRoute path={`${match.url}/:no_path/*`} exact>
            <ErrorPage404 />
          </AnnotationToolRoute>
        </Switch>
      </Suspense>
    </ConfigProvider>
  );
}

export default Contractor;
